import { FormCol } from "components/UI/Form/FormCol";
import { FormGrid } from "components/UI/Form/FormGrid";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { PartnerSelectSearchable } from "components/UI/Selects/PartnerSelectSearchable/PartnerSelectSearchable.tsx";
import { RefuseLeadsTypeSelectSearchable } from "components/UI/Selects/RefuseLeadsTypeSelectSearchable/RefuseLeadsTypeSelectSearchable.tsx";
import { StatusSelectSearchable } from "components/UI/Selects/StatusSelectSearchable/StatusSelectSearchable.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FormItem } from "react-hook-form-antd";

import { OfferApiFormEditFormData } from "../formSchema";

export const ApiFormProcessRefusedLeadsSection = () => {
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const { t } = usePaldockTranslation("forms.offer-api-form-edit");
    const { control, fieldNames } = useGeneralForm<OfferApiFormEditFormData>();

    return (
        <FormCol>
            <FormGrid cols={2}>
                <FormItem control={control} name={fieldNames.process_refuse_leads_active?.name || "process_refuse_leads_active"} label={t("fields.process_refuse_leads.label")}>
                    <StatusSelectSearchable />
                </FormItem>
                <FormItem
                    control={control}
                    name={fieldNames.process_refuse_leads_types?.name || "process_refuse_leads_types"}
                    label={tFields("type.label")}
                >
                    <RefuseLeadsTypeSelectSearchable mode="multiple" />
                </FormItem>
            </FormGrid>
            <FormGrid cols={2}>
                <FormItem
                    control={control}
                    name={fieldNames.process_included_user_ids?.name || "process_included_user_ids"}
                    label={tFields("included_partners.label")}
                >
                    <PartnerSelectSearchable mode="multiple" allowClear={true} />
                </FormItem>
                <FormItem
                    control={control}
                    name={fieldNames.process_excluded_user_ids?.name || "process_excluded_user_ids"}
                    label={tFields("excluded_partners.label")}
                >
                    <PartnerSelectSearchable mode="multiple" allowClear={true} />
                </FormItem>
            </FormGrid>
        </FormCol>
    );
};
